import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./Contact.css";

const Contact = () => {
    const [inputValue, setInputValue] = useState({
        fname: "",
        email: "",
        subject: "",
        message: ""
    });

    const getValue = (e) => {
        const { name, value } = e.target;
        setInputValue((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const sentUserData = async (e) => {
        e.preventDefault();
        const { fname, email, message, subject } = inputValue;

        if (!fname) {
            toast.error('Name is required');
        } else if (!email.trim()) {
            toast.error('Email is required');
        } else if (!email.includes('@')) {
            toast.error('Invalid email');
        } else if (!subject) {
            toast.error("Subject is required");
        } else {
            try {
                const res = await fetch('https://areebahmedportfolio.vercel.app/register', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        fname, email, message, subject
                    })
                });

                const data = await res.json();
                if (data.status == 201) {
                    setInputValue({

                        ...inputValue,
                        fname: "",
                        email: "",
                        subject: "",
                        message: ""
                    });
                    toast.success("Your response has been submitted successfully");
                }

            } catch (error) {
                console.error('Error:', error.message);
                toast.error("An error occurred while submitting the form");
            }
        }

    };

    return (
        <div className='contact-container'>
            <div className='contact-form d-flex justify-content-center'>
                <div className='col-lg-6 col-md-8 col-sm-10'>
                    <div className="contact-glass-panel">
                        <h2 className='contact-heading'>Contact Me</h2>
                        <Form>
                            <Form.Group className="mb-4" controlId="formBasicName">
                                <Form.Label className="form-label">Name</Form.Label>
                                <Form.Control type="text" name="fname" value={inputValue.fname} onChange={getValue} className="input" placeholder="Enter your name" />
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="formBasicEmail">
                                <Form.Label className="form-label">Email</Form.Label>
                                <Form.Control type="email" name="email" value={inputValue.email} onChange={getValue} className="input" placeholder="Enter your email" />
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="formBasicSubject">
                                <Form.Label className="form-label">Subject</Form.Label>
                                <Form.Control type="text" name="subject" value={inputValue.subject} onChange={getValue} className="input" placeholder="Enter subject" />
                            </Form.Group>
                            <Form.Group className="mb-4" controlId="formBasicMessage">
                                <Form.Label className="form-label">Message</Form.Label>
                                <Form.Control as="textarea" rows={5} name="message" value={inputValue.message} onChange={getValue} className="input" placeholder="Your message here..." />
                            </Form.Group>
                            <div className='d-flex justify-content-center mt-2'>
                                <button className='submit-btn' type="submit" onClick={sentUserData}>
                                    Send Message
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="bottom-right"
                theme="dark"
                toastStyle={{ backgroundColor: 'var(--glass-bg)', backdropFilter: 'blur(12px)', border: '1px solid var(--glass-border)', color: 'var(--text-primary)' }}
            />
        </div>
    );
}

export default Contact;
